// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + "dynamic-import-insitepanel" + "." + "5bee66967585670ad67b" + ".css";
};